<!--
 * @Date: 2023-08-16 14:55:51
 * @LastEditors: Cclay
 * @LastEditTime: 2023-10-17 18:12:06
 * @FilePath: \zl_api_private_web\src\views\systemSet\OperationLog.vue
 * @Description: 操作日志
-->
<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>操作日志</el-breadcrumb-item>
    </el-breadcrumb>
    <h1 class="view-head">
      操作日志
      <div class="title-btn">
        <el-button
          type="warning"
          plain
          @click="onExport"
          v-if="$store.state.funcModuleArray.includes(1901070201)"
          >导出</el-button
        >
      </div>
    </h1>
    <div class="view-content">
      <el-card class="box-card">
        <div class="view-filter">
          <el-form :inline="true" :model="filterForm">
            <el-form-item label="操作时间">
              <el-date-picker
                value-format="yyyy-MM-dd"
                size="small"
                v-model="filterForm.date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期 "
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="操作功能" style="margin-left: 25px">
              <el-input
                v-model="filterForm.search_text"
                class="search-text"
                size="small"
                style="width: 250px"
              >
              </el-input>
            </el-form-item>

            <el-form-item label="" style="margin-left: 25px">
              <el-input
                v-model="filterForm.operate_nickname"
                class="search-text"
                size="small"
                placeholder="请输入操作人姓名"
              >
                <el-button slot="append" @click="onSearch">查找</el-button>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="card-content">
          <div class="table-tool">共{{ totalCount }}条结果</div>
          <el-table
            v-loading="tableDataLoading"
            :data="tableData"
            style="width: 100%"
          >
            <el-table-column width="350" prop="create_time" label="操作时间">
            </el-table-column>
            <el-table-column width="200" prop="operate_nickname" label="操作人">
            </el-table-column>
            <el-table-column width="350" prop="function_name" label="操作功能">
            </el-table-column>
            <el-table-column width="350" prop="intro" label="操作内容">
            </el-table-column>
            <el-table-column prop="operator_content" label="操作对象">
              <template slot-scope="scope">
                <p :title="scope.row.operator_content" class="line2-font">
                  {{ scope.row.operator_content }}
                </p>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="block" v-if="totalPage > 1">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="20"
            layout="prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { getLogPage } from "@/api/index";
import { operateLogExport } from "@/api/export";
import moment from "moment";
export default {
  data: () => {
    return {
      filterForm: {
        date: "",
        search_text: "",
        operate_nickname: ''
      },
      totalCount: 0,
      totalPage: 0,
      currentPage: 0,
      tableDataLoading: false,
      tableData: [],
      page: 1
    };
  },
  created() {
    this.filterForm.date = [
      moment()
        .startOf("month")
        .format("YYYY-MM-DD"),
      moment()
        .endOf("month")
        .format("YYYY-MM-DD")
    ];
    this._getList();
  },
  methods: {
    onExport() {
      this._getList(1);
    },
    handleCurrentChange(e) {
      this.page = e;
      this._getList();
    },
    onSearch() {
      this.page = 1;
      this._getList();
    },
    apiParamAdapter(is_export) {
      let parameters = { ...this.filterForm };
      if (parameters.date && parameters.date.length) {
        parameters.start_date = parameters.date[0];
        parameters.end_date = parameters.date[1];
      } else {
        parameters.start_date = "";
        parameters.end_date = "";
      }

      delete parameters.date;
      parameters.is_export = is_export;
      parameters.page = this.page;
      return parameters;
    },
    async _getList(is_export = 0) {
      let parameters = this.apiParamAdapter(is_export);
      if (is_export == 0) {
        const { data, status } = await getLogPage(parameters);
        if (status == 0) {
          this.tableData = data.list;
          this.totalCount = data.totalCount;
          this.currentPage = parseInt(data.currentPage);
          this.totalPage = data.totalPage;
        } else {
          this.$message.error(data.msg);
          this.tableData = [];
          this.currentPage = 1;
          this.totalCount = 0;
          this.totalPage = 0;
        }
      } else {
        operateLogExport(parameters);
      }
    }
  }
};
</script>

<style scoped>
.line2-font {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
</style>
